import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
  Inputs
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";

import { useSelector, useDispatch } from "react-redux";

const { Text } = Inputs;

function ContactosList({ history, match }) {
  const dispatch = useDispatch();

  const modelContactos = useSelector((state) => state.getContactos);

  const [contactos, setContactos] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [nombre, setNombre] = useState("");
  const [documento, setDocumento] = useState("");

  useEffect(() => {
    const data = modelContactos?.data?.data;
    const error = modelContactos?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetContactos.actions.clear());
    }
    if (data) {
      setContactos(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetContactos.actions.clear());
    }
  }, [modelContactos]);

  useEffect(() => {
    dispatch(
      controller.getContactosThunk(match.params.organizacion, 1, pageSize)
    );
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setContactos([]);
    dispatch(
      controller.getContactosThunk(
        match.params.organizacion,
        page + 1,
        pageSize,
        nombre,
        documento
      )
    );
  }

  return (
    <Content
      title="Contactos"
      subTitle="Contactos"
      browserTitle="Contactos"
      show={false}
    >
      <Row>
        <Col md="8" mdOffset="2">
          <Box title="Contactos">
          <Col md="12">

              <Col md="3">
                <Text
                  labelPosition="above"
                  size="md"
                  label="Nombre"
                  value={nombre}
                  onChange={(evt) => setNombre(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="md"
                  label="Documento"
                  value={documento}
                  onChange={(evt) => setDocumento(evt.target.value)}
                />
              </Col>

              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col>
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(`/addContacto/${match.params.organizacion}`)
              }
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {contactos && contactos.length > 0 ? (
              <SimpleTable
                hover={true}
                data={contactos.map((row, index) => {
                  return {
                    nombre: row.nombre,
                    documento: row.documento,
                    telefono: row.telefono,
                    email: row.email,
                    editar: (
                      <Button
                        type="primary"
                        text="Editar"
                        onClick={() => history.push(`/editContacto/${row._id}`)}
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Documento", data: "documento" },
                  { title: "Telefono", data: "telefono" },
                  { title: "Email", data: "email" },
          
                  { title: "Editar", data: "editar" },
                ]}
              />
            ) : (
              <h4>No se han encontrado ambientes</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ContactosList;
